import { Pipe, PipeTransform } from '@angular/core';
import { CommonService } from '../services/common.service';

@Pipe({
  name: 'twelvehourtimeformatter'
})
export class TwelvehourtimeformatterPipe implements PipeTransform {
  constructor(private commonService: CommonService)
  {

  }

  transform(value: string): string {
    if (!value) {
      return value;
    }
    let twelevehrTimeFormat:boolean = this.commonService.miscConfig['12hrTimeFormat'] === 'false' ? false : this.commonService.miscConfig['12hrTimeFormat'];

    const [hours, minutes] = value.split(':');

    const tempValue = value?.toLowerCase();
    let formattedTime = '';
    if (twelevehrTimeFormat && (tempValue.indexOf('am') === -1 && tempValue.indexOf('pm') === -1)) {
      const hour = parseInt(hours, 10);
      const period = hour >= 12 ? 'PM' : 'AM';
      const formattedHour = (hour % 12 === 0) ? 12 : hour % 12;
      formattedTime = `${formattedHour}:${minutes} ${period}`;
    } else {
      formattedTime = value;
    }

    return formattedTime;
  }

}
